import { Injectable } from '@angular/core';
import { FilterOrSearchModel } from 'src/app/models/filter-or-search.model';

@Injectable({
  providedIn: 'root'
})
export class AdvancedSearchStateService {
  private _stateByInstance: Record<string, Partial<FilterOrSearchModel>> = {};
  private _currentInstanceId: string | null = null;

  constructor() { }

  setInstanceId(instanceId: string | null | undefined): void {
    this._currentInstanceId = instanceId ? instanceId.toLowerCase() : null;
  }

  setState(newState: Partial<FilterOrSearchModel>, instanceId?: string): void {
    const key = (instanceId || this._currentInstanceId || 'default').toLowerCase();
    this._stateByInstance[key] = { ...(this._stateByInstance[key] || {}), ...newState };
  }

  getState(instanceId?: string): Partial<FilterOrSearchModel> {
    const key = (instanceId || this._currentInstanceId || 'default').toLowerCase();
    return this._stateByInstance[key] || {};
  }

  clearState(instanceId?: string): void {
    if (instanceId) {
      delete this._stateByInstance[instanceId.toLowerCase()];
    } else if (this._currentInstanceId) {
      delete this._stateByInstance[this._currentInstanceId];
    } else {
      this._stateByInstance = {};
    }
  }
}